import { getSdk } from "./sdkService";

export const WEB_PORTAL_STG = "https://web3-stg.starzplay.com";
export const WEB_PORTAL_PROD = "https://starzplay.com";
export const SIGNATURE_KEY_STG = "BUrO7X!HQsXU39XH";
export const SIGNATURE_KEY_PROD = "H$Kwc@aMKReKKhN9";
/**
 * Get status of an Asset or get get all assets
 * if assetId is not specified then returns all assets otherwise get details of one asset
 * @public
 */
export async function getTVODAssetsStatus(assetId = null, pageSize = null, pageNo = null) {
  try {
    const queryParams = {
      assetId,
      pageNo,
      pageSize
    };
    const sdk = await getSdk();
    return await sdk.userManager.getTVODAssetsStatus(queryParams, localStorage.getItem("globalUserId"));
  } catch (error) {
    throw error;
  }
}

export async function updateTVODAssetsStatus(assetId = null) {
  try {
    const queryParams = {
      assetId
    };
    const sdk = await getSdk();
    return await sdk.userManager.getTVODAssetsStatus(queryParams);
  } catch (error) {
    throw error;
  }
}
export async function getTVODProductPrices(priceProducts = [], country = "") {
  try {
    const queryParams = {
      priceProducts: priceProducts.toString(),
      country
    };
    const sdk = await getSdk();
    return await sdk.userManager.getTVODProductPrices(queryParams);
  } catch (error) {
    throw error;
  }
}

export async function getOneTimeAuthToken() {
  try {
    const sdk = await getSdk();
    const { data } = await sdk.authenticationManager.authToken();
    return data.token;
  } catch (error) {
    throw error;
  }
}

export function getWebPortalURL() {
  let env = process.env.NODE_ENV;
  env = window.location.href.includes("stg") ? "staging" : env;
  const url = env === "development" || env === "staging" ? WEB_PORTAL_STG : WEB_PORTAL_PROD;
  return url;
}

export function getSignatureKey() {
  let env = process.env.NODE_ENV;
  env = window.location.href.includes("stg") ? "staging" : env;
  const url = env === "development" || env === "staging" ? SIGNATURE_KEY_STG : SIGNATURE_KEY_PROD;
  return url;
}
